export default __webpack_public_path__ + "5320da5275ac23adb98e7ebf6520e949.png";